// External libraries
import React from 'react';
// @ts-expect-error checkout/react-components
import { CloseIcon } from '@checkout/react-components';

// Internal modules
import type { AlertTypes } from './constants';
import { AlertContainer, AlertMessage, IconButton } from './StyledComponents';

interface AlertProps {
  children: React.ReactNode;
  type: AlertTypes;
}

const styleOverrides = {
  flexBasis: 70,
  svg: {
    height: 15,
    width: 15,
  },
};

const Alert = ({ children, type }: AlertProps): React.ReactElement | null => {
  const [closed, setClosed] = React.useState<boolean>(false);

  const handleClose = () => {
    setClosed(true);
  };

  if (closed) {
    return null;
  }

  return (
    <AlertContainer type={type} data-testid="alert-container">
      <AlertMessage type={type}>{children}</AlertMessage>
      <IconButton onClick={handleClose} styleOverrides={styleOverrides}>
        <CloseIcon />
      </IconButton>
    </AlertContainer>
  );
};

export { Alert };
